import { render, staticRenderFns } from "./CredlySettings.vue?vue&type=template&id=1a515b6a&scoped=true"
import script from "./CredlySettings.vue?vue&type=script&lang=js"
export * from "./CredlySettings.vue?vue&type=script&lang=js"
import style0 from "./CredlySettings.vue?vue&type=style&index=0&id=1a515b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a515b6a",
  null
  
)

export default component.exports